/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddWorkflowEdgeRequest } from '../models/AddWorkflowEdgeRequest';
import type { AddWorkflowEdgeResponse } from '../models/AddWorkflowEdgeResponse';
import type { AddWorkflowNodeRequest } from '../models/AddWorkflowNodeRequest';
import type { AddWorkflowNodeResponse } from '../models/AddWorkflowNodeResponse';
import type { ExecuteWorkflowNotificationTaskRequest } from '../models/ExecuteWorkflowNotificationTaskRequest';
import type { GetGoogleAuthTokenRequest } from '../models/GetGoogleAuthTokenRequest';
import type { GetGoogleGmailOAuthTokensResult } from '../models/GetGoogleGmailOAuthTokensResult';
import type { GetMicrosoftAuthTokenRequest } from '../models/GetMicrosoftAuthTokenRequest';
import type { GetMicrosoftOAuthTokensResult } from '../models/GetMicrosoftOAuthTokensResult';
import type { ListWorkflowFilesAndDirectoriesResponse } from '../models/ListWorkflowFilesAndDirectoriesResponse';
import type { ManualCancelBulkWorkflowExecutionRequest } from '../models/ManualCancelBulkWorkflowExecutionRequest';
import type { ManualKickOffBulkWorkflowExecutionRequest } from '../models/ManualKickOffBulkWorkflowExecutionRequest';
import type { ManualPauseBulkWorkflowExecutionRequest } from '../models/ManualPauseBulkWorkflowExecutionRequest';
import type { ManualResumeBulkWorkflowExecutionRequest } from '../models/ManualResumeBulkWorkflowExecutionRequest';
import type { ManualSkipNodeBulkWorkflowExecutionRequest } from '../models/ManualSkipNodeBulkWorkflowExecutionRequest';
import type { OrgProfileIntegration } from '../models/OrgProfileIntegration';
import type { PresignedUrlResponse } from '../models/PresignedUrlResponse';
import type { ProvisionOrgWorkflowRequest } from '../models/ProvisionOrgWorkflowRequest';
import type { ProvisionOrgWorkflowResponse } from '../models/ProvisionOrgWorkflowResponse';
import type { ProvisionWorkflowRequest } from '../models/ProvisionWorkflowRequest';
import type { ProvisionWorkflowResponse } from '../models/ProvisionWorkflowResponse';
import type { PublishWorkflowResponse } from '../models/PublishWorkflowResponse';
import type { SendWorkflowNotificationEmailRequest } from '../models/SendWorkflowNotificationEmailRequest';
import type { SendWorkflowNotificationSMSRequest } from '../models/SendWorkflowNotificationSMSRequest';
import type { StringStringValuesKeyValuePair } from '../models/StringStringValuesKeyValuePair';
import type { TestNodeRequest } from '../models/TestNodeRequest';
import type { TestNodeResponse } from '../models/TestNodeResponse';
import type { TimerPausedWorkflowExecutionResponse } from '../models/TimerPausedWorkflowExecutionResponse';
import type { TriggerPausedOrgWorkflowExecutionRequest } from '../models/TriggerPausedOrgWorkflowExecutionRequest';
import type { TriggerScheduledOrgWorkflowExecutionRequest } from '../models/TriggerScheduledOrgWorkflowExecutionRequest';
import type { TriggerScheduledWorkflowExecutionRequest } from '../models/TriggerScheduledWorkflowExecutionRequest';
import type { UnpublishWorkflowResponse } from '../models/UnpublishWorkflowResponse';
import type { UpdateWorkflowConfigRequest } from '../models/UpdateWorkflowConfigRequest';
import type { UpdateWorkflowEdgeRequest } from '../models/UpdateWorkflowEdgeRequest';
import type { UpdateWorkflowEdgeResponse } from '../models/UpdateWorkflowEdgeResponse';
import type { UpdateWorkflowNodeRequest } from '../models/UpdateWorkflowNodeRequest';
import type { UpdateWorkflowNodeResponse } from '../models/UpdateWorkflowNodeResponse';
import type { UpdateWorkflowRequest } from '../models/UpdateWorkflowRequest';
import type { UpdateWorkflowResponse } from '../models/UpdateWorkflowResponse';
import type { UploadWorkflowFilesRequest } from '../models/UploadWorkflowFilesRequest';
import type { UploadWorkflowFilesResponse } from '../models/UploadWorkflowFilesResponse';
import type { UserPausedWorkflowExecutionResponse } from '../models/UserPausedWorkflowExecutionResponse';
import type { Workflow } from '../models/Workflow';
import type { WorkflowCreateDirRequest } from '../models/WorkflowCreateDirRequest';
import type { WorkflowCreateDirResponse } from '../models/WorkflowCreateDirResponse';
import type { WorkflowEntityLink } from '../models/WorkflowEntityLink';
import type { WorkflowExecution } from '../models/WorkflowExecution';
import type { WorkflowNotification } from '../models/WorkflowNotification';
import type { WorkflowNotificationTask } from '../models/WorkflowNotificationTask';
import type { WorkflowNotificationType } from '../models/WorkflowNotificationType';
import type { WorkflowsAiOutboundPhoneCallNodeSendEmailResponse } from '../models/WorkflowsAiOutboundPhoneCallNodeSendEmailResponse';
import type { WorkflowsAiOutboundPhoneCallNodeSendTextResponse } from '../models/WorkflowsAiOutboundPhoneCallNodeSendTextResponse';
import type { WorkflowsAiOutboundPhoneCallNodeWebSocketResponse } from '../models/WorkflowsAiOutboundPhoneCallNodeWebSocketResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WorkflowsService {

    /**
     * Adds a new edge (or connection) to the workflow.
     * @param workflowId The Id of the workflow
     * @param requestBody The request to create a project.
     * @returns AddWorkflowEdgeResponse OK
     * @throws ApiError
     */
    public static addWorkflowEdge(
        workflowId: string,
        requestBody?: AddWorkflowEdgeRequest,
    ): CancelablePromise<AddWorkflowEdgeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows/{workflowId}/edges/add',
            path: {
                'workflowId': workflowId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Adds a new node to the workflow.
     * @param workflowId The Id of the workflow
     * @param requestBody The request to create a project.
     * @returns AddWorkflowNodeResponse OK
     * @throws ApiError
     */
    public static addWorkflowNode(
        workflowId: string,
        requestBody?: AddWorkflowNodeRequest,
    ): CancelablePromise<AddWorkflowNodeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows/{workflowId}/nodes/add',
            path: {
                'workflowId': workflowId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Provisions a workflow.
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static aiOutboundPhoneCallNodeEndCall(
        requestBody?: any,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aiphonecall/endcall',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Provisions a workflow.
     * @param requestBody
     * @returns WorkflowsAiOutboundPhoneCallNodeSendEmailResponse OK
     * @throws ApiError
     */
    public static aiOutboundPhoneCallNodeSendEmail(
        requestBody?: any,
    ): CancelablePromise<WorkflowsAiOutboundPhoneCallNodeSendEmailResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aiphonecall/sendEmail',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Provisions a workflow.
     * @param requestBody
     * @returns WorkflowsAiOutboundPhoneCallNodeSendTextResponse OK
     * @throws ApiError
     */
    public static aiOutboundPhoneCallNodeSendText(
        requestBody?: any,
    ): CancelablePromise<WorkflowsAiOutboundPhoneCallNodeSendTextResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aiphonecall/sendtext',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Provisions a workflow.
     * @param workflowId The workflow id to perform dry run
     * @param workflowExecutionId
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static aiOutboundPhoneCallNodeWebSocketResponse(
        workflowId: string,
        workflowExecutionId: string,
        requestBody?: WorkflowsAiOutboundPhoneCallNodeWebSocketResponse,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows/{workflowId}/executions/{workflowExecutionId}/aiPhonecall-socket-response',
            path: {
                'workflowId': workflowId,
                'workflowExecutionId': workflowExecutionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Upload files on behalf of a workflow.
     * @param requestBody request body
     * @returns WorkflowCreateDirResponse OK
     * @throws ApiError
     */
    public static createDir(
        requestBody?: WorkflowCreateDirRequest,
    ): CancelablePromise<WorkflowCreateDirResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflow/createDir',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Deletes a workflow.
     * @param workflowId The ID of the workflow to delete.
     * @returns any OK
     * @throws ApiError
     */
    public static deleteWorkflow(
        workflowId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows/{workflowId}/delete',
            path: {
                'workflowId': workflowId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Provisions a workflow.
     * @param workflowId The workflow id to perform dry run
     * @returns any OK
     * @throws ApiError
     */
    public static dryRunWorkflow(
        workflowId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflow/{workflowId}/dryrun',
            path: {
                'workflowId': workflowId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Retrieve all pending tasks for the specified organization.
     * @param organizationId
     * @param taskId
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static executeWorkflowNotificationTask(
        organizationId: string,
        taskId: string,
        requestBody?: ExecuteWorkflowNotificationTaskRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organization/{organizationId}/tasks/{taskId}/execute',
            path: {
                'organizationId': organizationId,
                'taskId': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

    /**
     * @deprecated
     * This endpoint is deprecated. Use `/integrations/gmail/getGmailOAuthTokens` instead.
     * @param workflowId
     * @param requestBody
     * @returns GetGoogleGmailOAuthTokensResult OK
     * @throws ApiError
     */
    public static getGoogleGmailOAuthTokens(
        workflowId: string,
        requestBody?: GetGoogleAuthTokenRequest,
    ): CancelablePromise<GetGoogleGmailOAuthTokensResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows/{workflowId}/getGoogleGmailOAuthTokens',
            path: {
                'workflowId': workflowId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @deprecated
     * This endpoint is deprecated. Use `/integrations/gmail/getMicrosoftOutlookOAuthTokens` instead.
     * @param workflowId
     * @param requestBody
     * @returns GetMicrosoftOAuthTokensResult OK
     * @throws ApiError
     */
    public static getMicrosoftOutlookOAuthTokens(
        workflowId: string,
        requestBody?: GetMicrosoftAuthTokenRequest,
    ): CancelablePromise<GetMicrosoftOAuthTokensResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows/{workflowId}/getMicrosoftOutlookOAuthTokens',
            path: {
                'workflowId': workflowId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Retrieve all workflows for the specified organization.
     * This returns only those workflows that is tied up with only organization, and not organization and workspace together.
     * @param organizationId The ID of the organization.
     * @returns Workflow OK
     * @throws ApiError
     */
    public static getOrgWorkflows(
        organizationId: string,
    ): CancelablePromise<Array<Workflow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/workflows_o/{organizationId}',
            path: {
                'organizationId': organizationId,
            },
        });
    }

    /**
     * Retrieve all saved oauth sonnections for the specified organization.
     * This returns only those those connections that are tied up with only organization
     * @param organizationId The ID of the organization.
     * @returns OrgProfileIntegration OK
     * @throws ApiError
     */
    public static getSavedWorkflowOauthConnections(
        organizationId: string,
    ): CancelablePromise<Array<OrgProfileIntegration>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/workflows_o/{organizationId}/oauthConnections',
            path: {
                'organizationId': organizationId,
            },
        });
    }

    /**
     * Retrieve all executions for the specified workflow.
     * @param workflowId The ID of the workflow.
     * @returns TimerPausedWorkflowExecutionResponse OK
     * @throws ApiError
     */
    public static getTimerPausedWorkflowExecutions(
        workflowId: string,
    ): CancelablePromise<TimerPausedWorkflowExecutionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/workflow/{workflowId}/executions/paused',
            path: {
                'workflowId': workflowId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Retrieve all executions for the specified workflow.
     * @param workflowId The ID of the workflow.
     * @returns UserPausedWorkflowExecutionResponse OK
     * @throws ApiError
     */
    public static getUserPausedWorkflowExecutions(
        workflowId: string,
    ): CancelablePromise<UserPausedWorkflowExecutionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/workflow/{workflowId}/executions/paused/user',
            path: {
                'workflowId': workflowId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Retrieve all workflows for the specified workspace, excluding those created via the external API.
     * @param workflowId The ID of the workflow.
     * @returns Workflow OK
     * @throws ApiError
     */
    public static getWorkflow(
        workflowId: string,
    ): CancelablePromise<Workflow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/workflow/{workflowId}',
            path: {
                'workflowId': workflowId,
            },
        });
    }

    /**
     * Retrieves the workflow entity links for a given workflow.
     * This endpoint is used to get the account
     * @param workflowId The ID of the workflow.
     * @returns WorkflowEntityLink OK
     * @throws ApiError
     */
    public static getWorkflowEntityLinks(
        workflowId: string,
    ): CancelablePromise<Array<WorkflowEntityLink>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/workflows/{workflowId}/workflowEntityLinks',
            path: {
                'workflowId': workflowId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Retrieve all executions for the specified workflow.
     * @param workflowId The ID of the workflow.
     * @returns WorkflowExecution OK
     * @throws ApiError
     */
    public static getWorkflowExecutions(
        workflowId: string,
    ): CancelablePromise<Array<WorkflowExecution>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/workflow/{workflowId}/executions',
            path: {
                'workflowId': workflowId,
            },
        });
    }

    /**
     * Retrieve all workflows for the specified workspace, excluding those created via the external API.
     * @param organizationId The organization id
     * @param workflowId The ID of the workflow.
     * @param path path to search files and dirs
     * @returns ListWorkflowFilesAndDirectoriesResponse OK
     * @throws ApiError
     */
    public static listWorkflowFilesAndDirectories(
        organizationId: string,
        workflowId: string,
        path?: string,
    ): CancelablePromise<ListWorkflowFilesAndDirectoriesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizations/{organizationId}/workflow/{workflowId}/filesAndDirs',
            path: {
                'organizationId': organizationId,
                'workflowId': workflowId,
            },
            query: {
                'path': path,
            },
        });
    }

    /**
     * Triggers a scheduled org level workflow execution on receiving message from PubSub
     * NOTE : This endpoint is only for PubSub to trigger the workflow execution and this endpoint will only be used in production
     * In Development, scheduled executions are taken care by background service i.e SchedulerService.cs
     * @param workflowId The workflow id to be executed
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static manualCancelBulkWorkflowExecution(
        workflowId: string,
        requestBody?: ManualCancelBulkWorkflowExecutionRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows_o/{workflowId}/cancel',
            path: {
                'workflowId': workflowId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Triggers a scheduled org level workflow execution on receiving message from PubSub
     * NOTE : This endpoint is only for PubSub to trigger the workflow execution and this endpoint will only be used in production
     * In Development, scheduled executions are taken care by background service i.e SchedulerService.cs
     * @param workflowId The workflow id to be executed
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static manualKickOffBulkWorkflowExecution(
        workflowId: string,
        requestBody?: ManualKickOffBulkWorkflowExecutionRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows_o/{workflowId}/manualrun',
            path: {
                'workflowId': workflowId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Triggers a scheduled org level workflow execution on receiving message from PubSub
     * NOTE : This endpoint is only for PubSub to trigger the workflow execution and this endpoint will only be used in production
     * In Development, scheduled executions are taken care by background service i.e SchedulerService.cs
     * @param workflowId The workflow id to be executed
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static manualPauseBulkWorkflowExecution(
        workflowId: string,
        requestBody?: ManualPauseBulkWorkflowExecutionRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows_o/{workflowId}/manualpause',
            path: {
                'workflowId': workflowId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Triggers a scheduled org level workflow execution on receiving message from PubSub
     * NOTE : This endpoint is only for PubSub to trigger the workflow execution and this endpoint will only be used in production
     * In Development, scheduled executions are taken care by background service i.e SchedulerService.cs
     * @param workflowId The workflow id to be executed
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static manualResumeBulkWorkflowExecution(
        workflowId: string,
        requestBody?: ManualResumeBulkWorkflowExecutionRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows_o/{workflowId}/manualresume',
            path: {
                'workflowId': workflowId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Triggers a scheduled org level workflow execution on receiving message from PubSub
     * NOTE : This endpoint is only for PubSub to trigger the workflow execution and this endpoint will only be used in production
     * In Development, scheduled executions are taken care by background service i.e SchedulerService.cs
     * @param workflowId The workflow id to be executed
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static manualSkipNodeBulkWorkflowExecution(
        workflowId: string,
        requestBody?: ManualSkipNodeBulkWorkflowExecutionRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows_o/{workflowId}/manualskip',
            path: {
                'workflowId': workflowId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Generates a pre-signed URL for a notification task resource.
     * @param organizationId The organization ID.
     * @param taskId The task ID.
     * @param taskResourceId The task resource ID.
     * @returns PresignedUrlResponse OK
     * @throws ApiError
     */
    public static notificationTaskResourcePresignedUrl(
        organizationId: string,
        taskId: string,
        taskResourceId: string,
    ): CancelablePromise<PresignedUrlResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organization/{organizationId}/tasks/{taskId}/task-resources/{taskResourceId}/presigned-url',
            path: {
                'organizationId': organizationId,
                'taskId': taskId,
                'taskResourceId': taskResourceId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Provisions a org level workflow.
     * NOTE: For now we are keeping this seperate from the workspace level workflows.
     * @param requestBody The request to create a project.
     * @returns ProvisionOrgWorkflowResponse OK
     * @throws ApiError
     */
    public static provisionOrgWorkflow(
        requestBody?: ProvisionOrgWorkflowRequest,
    ): CancelablePromise<ProvisionOrgWorkflowResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows_o/provision',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Provisions a workflow.
     * @param requestBody The request to create a project.
     * @returns ProvisionWorkflowResponse OK
     * @throws ApiError
     */
    public static provisionWorkflow(
        requestBody?: ProvisionWorkflowRequest,
    ): CancelablePromise<ProvisionWorkflowResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows/provision',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param workflowId
     * @returns PublishWorkflowResponse OK
     * @throws ApiError
     */
    public static publishWorkflow(
        workflowId: string,
    ): CancelablePromise<PublishWorkflowResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows/{workflowId}/publish',
            path: {
                'workflowId': workflowId,
            },
            errors: {
                404: `Not Found`,
                409: `Conflict`,
            },
        });
    }

    /**
     * Deletes an edge from an workflow.
     * @param workflowId The ID of the workflow.
     * @param edgeId The ID of the edge.
     * @returns any OK
     * @throws ApiError
     */
    public static removeWorkflowEdge(
        workflowId: string,
        edgeId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows/{workflowId}/edges/{edgeId}/delete',
            path: {
                'workflowId': workflowId,
                'edgeId': edgeId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Deletes a node from an workflow.
     * @param workflowId The ID of the workflow.
     * @param nodeId The ID of the node.
     * @returns any OK
     * @throws ApiError
     */
    public static removeWorkflowNode(
        workflowId: string,
        nodeId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows/{workflowId}/nodes/{nodeId}/delete',
            path: {
                'workflowId': workflowId,
                'nodeId': nodeId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Sends a message to a conversation thread in Twilio.
     * @param requestBody Request body
     * @returns any OK
     * @throws ApiError
     */
    public static sendWorkflowNotificationEmail(
        requestBody?: SendWorkflowNotificationEmailRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflow/notifications/sendEmail',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Sends a message to a conversation thread in Twilio.
     * @param requestBody Request body
     * @returns any OK
     * @throws ApiError
     */
    public static sendWorkflowNotificationSms(
        requestBody?: SendWorkflowNotificationSMSRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflow/notifications/sendSMS',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Updates an existing workflow's node.
     * @param workflowId The ID of the workflow.
     * @param nodeId The ID of the workflow node to update.
     * @param requestBody The request to update the organization.
     * @returns TestNodeResponse OK
     * @throws ApiError
     */
    public static testNode(
        workflowId: string,
        nodeId: string,
        requestBody?: TestNodeRequest,
    ): CancelablePromise<TestNodeResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/workflows/{workflowId}/nodes/{nodeId}/Test',
            path: {
                'workflowId': workflowId,
                'nodeId': nodeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Triggers a scheduled org level workflow execution on receiving message from PubSub
     * NOTE : This endpoint is only for PubSub to trigger the workflow execution and this endpoint will only be used in production
     * In Development, scheduled executions are taken care by background service i.e SchedulerService.cs
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static triggerPausedOrgWorkflowExecution(
        requestBody?: TriggerPausedOrgWorkflowExecutionRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows_o/trigger/resume',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Triggers a scheduled org level workflow execution on receiving message from PubSub
     * NOTE : This endpoint is only for PubSub to trigger the workflow execution and this endpoint will only be used in production
     * In Development, scheduled executions are taken care by background service i.e SchedulerService.cs
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static triggerScheduledOrgBulkWorkflowExecution(
        requestBody?: TriggerScheduledOrgWorkflowExecutionRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows_o/trigger/bulk',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Triggers a scheduled org level workflow execution on receiving message from PubSub
     * NOTE : This endpoint is only for PubSub to trigger the workflow execution and this endpoint will only be used in production
     * In Development, scheduled executions are taken care by background service i.e SchedulerService.cs
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static triggerScheduledOrgWorkflowExecution(
        requestBody?: TriggerScheduledOrgWorkflowExecutionRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows_o/trigger',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Triggers a scheduled project level workflow execution on receiving message from PubSub
     * NOTE : This endpoint is only for PubSub to trigger the workflow execution and this endpoint will only be used in production
     * In Development, scheduled executions are taken care by background service i.e SchedulerService.cs
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static triggerScheduledWorkflowExecution(
        requestBody?: TriggerScheduledWorkflowExecutionRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows/trigger',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * @param workflowId
     * @returns UnpublishWorkflowResponse OK
     * @throws ApiError
     */
    public static unpublishBulkWorkflow(
        workflowId: string,
    ): CancelablePromise<UnpublishWorkflowResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows/{workflowId}/unpublish_bulk',
            path: {
                'workflowId': workflowId,
            },
            errors: {
                404: `Not Found`,
                409: `Conflict`,
            },
        });
    }

    /**
     * Updates an existing workflow's details.
     * @param workflowId The ID of the workflow to update.
     * @param requestBody The request to update the organization.
     * @returns UpdateWorkflowResponse OK
     * @throws ApiError
     */
    public static updateWorkflow(
        workflowId: string,
        requestBody?: UpdateWorkflowRequest,
    ): CancelablePromise<UpdateWorkflowResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/workflows/{workflowId}/update',
            path: {
                'workflowId': workflowId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Deletes a workflow.
     * @param workflowId The ID of the workflow to delete.
     * @param requestBody The request to update the workflow config.
     * @returns any OK
     * @throws ApiError
     */
    public static updateWorkflowConfig(
        workflowId: string,
        requestBody?: UpdateWorkflowConfigRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows/{workflowId}/update-config',
            path: {
                'workflowId': workflowId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Updates an existing workflow's edge.
     * @param workflowId The ID of the workflow.
     * @param edgeId The ID of the workflow edge to update.
     * @param requestBody The request to update the organization.
     * @returns UpdateWorkflowEdgeResponse OK
     * @throws ApiError
     */
    public static updateWorkflowEdge(
        workflowId: string,
        edgeId: string,
        requestBody?: UpdateWorkflowEdgeRequest,
    ): CancelablePromise<UpdateWorkflowEdgeResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/workflows/{workflowId}/edges/{edgeId}/update',
            path: {
                'workflowId': workflowId,
                'edgeId': edgeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Updates an existing workflow's node.
     * @param workflowId The ID of the workflow.
     * @param nodeId The ID of the workflow node to update.
     * @param requestBody The request to update the organization.
     * @returns UpdateWorkflowNodeResponse OK
     * @throws ApiError
     */
    public static updateWorkflowNode(
        workflowId: string,
        nodeId: string,
        requestBody?: UpdateWorkflowNodeRequest,
    ): CancelablePromise<UpdateWorkflowNodeResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/workflows/{workflowId}/nodes/{nodeId}/update',
            path: {
                'workflowId': workflowId,
                'nodeId': nodeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Upload files on behalf of a workflow.
     * @param requestBody request body
     * @returns UploadWorkflowFilesResponse OK
     * @throws ApiError
     */
    public static uploadWorkflowFiles(
        requestBody?: UploadWorkflowFilesRequest,
    ): CancelablePromise<UploadWorkflowFilesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflow/uploadFiles',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @deprecated
     * This endpoint is deprecated. Use `/gmail/listen` instead.
     *
     *
     * Listens for any email replies on behalf of a user within a workflow if email node is present.
     * and stores the message as a notification in the database. This Endpoint is used with GCP Pub/Sub
     * @TODO: We need to revisit this to authenticate the request.
     *
     *
     *
     * This endpoint is deprecated. Use the integrations starting with `/integrations` route instead.
     * @param workflowId The id of the Workflow
     * @param nodeId The node id of the Workflow
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static workflowEmailListener(
        workflowId: string,
        nodeId: string,
        requestBody?: any,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows_o/{workflowId}/nodes/{nodeId}/email/listen',
            path: {
                'workflowId': workflowId,
                'nodeId': nodeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Retrieve all executions for the specified workflow.
     * @param organizationId
     * @param workflowId The ID of the workflow.
     * @param type
     * @returns WorkflowNotification OK
     * @throws ApiError
     */
    public static getWorkflowNotifications(
        organizationId?: string,
        workflowId?: string,
        type?: WorkflowNotificationType,
    ): CancelablePromise<Array<WorkflowNotification>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/workflow/notifications',
            query: {
                'organizationId': organizationId,
                'workflowId': workflowId,
                'type': type,
            },
        });
    }

    /**
     * Retrieve all pending tasks for the specified organization.
     * @param organizationId
     * @returns WorkflowNotificationTask OK
     * @throws ApiError
     */
    public static getWorkflowNotificationTasks(
        organizationId: string,
    ): CancelablePromise<Array<WorkflowNotificationTask>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organization/{organizationId}/tasks',
            path: {
                'organizationId': organizationId,
            },
        });
    }

    /**
     * Listens for any sms replies on behalf of a user within a workflow if sms node is present.
     * and stores the message as a notification in the database. This Endpoint is used with TWILIO primarily for now.
     * @TODO: We need to revisit this to authenticate the request.
     * @param formData
     * @returns any OK
     * @throws ApiError
     */
    public static workflowSmsListener(
        formData?: {
            formData?: Array<StringStringValuesKeyValuePair>;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows_o/sms/listen',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Retrieve all workflows for the specified workspace, excluding those created via the external API.
     * @param workspaceId The ID of the workspace to scope the projects for.
     * @returns Workflow OK
     * @throws ApiError
     */
    public static workflows(
        workspaceId: string,
    ): CancelablePromise<Array<Workflow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/workflows/{workspaceId}',
            path: {
                'workspaceId': workspaceId,
            },
        });
    }

}
